const organizationTypes = {
	seller: 'Seller',
	warehouse: 'Warehouse',
	superAdministrator: 'SuperAdmin',
};

export { organizationTypes };
